<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    import ios_icon from './assets/ios_icon.png';

    export default {
        name: 'app',
        computed: {
            socket: function() {
                return this.$store.state.socket;
            }
        }
    }
</script>

<style lang="scss">
    body {
        background: #1B1B1B;
        color: white
    }

    .card {
        background-color: #343A40;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue